import { defineIsland, defineIslands } from "@vuerend/core/runtime";
import "./styles/Site.css";
/** Pulls server-route SFC styles into shared CSS without hydrating the route component. */
import "virtual:wtrclred/post-route-style.css";
import HomeScrollFallbackView from "./features/HomeScrollFallback.vue";
import FavWebSortableGridView from "./features/FavWebSortableGrid.vue";
import PostsGraphView from "./features/HomePostsGraph.vue";
import SearchIslandView from "./features/SearchIsland.vue";
import WatercolorBackgroundIslandView from "./features/ShellWatercolorBackgroundIsland.vue";

const desktopIslandMedia = "(min-width: 769px)";

export const PostsGraphIsland = defineIsland("posts-graph", {
  component: PostsGraphView,
  load: () => import("./features/HomePostsGraphLoader"),
  hydrate: "media",
  media: desktopIslandMedia,
});

export const SearchIsland = defineIsland("search", {
  component: SearchIslandView,
  load: () => import("./features/SearchIslandLoader"),
  hydrate: "media",
  media: desktopIslandMedia,
});

export const WatercolorBackgroundIsland = defineIsland("watercolor-background", {
  component: WatercolorBackgroundIslandView,
  load: () => import("./features/ShellWatercolorBackgroundIslandLoader"),
  hydrate: "media",
  media: desktopIslandMedia,
});

export const HomeScrollFallbackIsland = defineIsland("home-scroll-fallback", {
  component: HomeScrollFallbackView,
  load: () => import("./features/HomeScrollFallbackLoader"),
  hydrate: "media",
  media: desktopIslandMedia,
});

export const FavWebSortableGridIsland = defineIsland("fav-web-sortable-grid", {
  component: FavWebSortableGridView,
  load: () => import("./features/FavWebSortableGridLoader"),
});

export default defineIslands([
  PostsGraphIsland,
  SearchIsland,
  WatercolorBackgroundIsland,
  HomeScrollFallbackIsland,
  FavWebSortableGridIsland,
]);
